import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrayJoinPipe } from './array-join.pipe';
import { CustomFuncFilterPipe } from './custom-func-filter.pipe';
import { DateWithFormatPipe } from './date-with-format.pipe';
import { EllipsisPipe } from './ellipsis.pipe';
import { HideFlaggedItemsPipe } from './hide-flagged-items.pipe';
import { MomentTimezonePipe } from './moment-timezone.pipe';
import { SearchPipe } from './search.pipe';
import { SecureVideoUrlPipePipe } from './secure-video-url-pipe.pipe';
import { SortByPipe } from './sort-by.pipe';
import { ToClassPipe } from './to-class.pipe';
import { L10nTranslationModule } from 'angular-l10n';
import { TranslationModule } from '@miq/utils';
import { TranslatePropertyTypePipe } from '@miq/utils/pipes';
import { ColumnTooltipPipe } from './column-tooltip.pipe';
import { DataCellFormatterPipe } from './data-cell-formatter.pipe';
import { CombineWithPipe } from './combine-with.pipe';
import { GetCountByPropertyPipe } from './get-count-by-property-pipe/get-count-by-property.pipe';

@NgModule({
  imports: [CommonModule, L10nTranslationModule, TranslationModule, TranslatePropertyTypePipe],
  declarations: [
    ArrayJoinPipe,
    CustomFuncFilterPipe,
    DateWithFormatPipe,
    EllipsisPipe,
    HideFlaggedItemsPipe,
    MomentTimezonePipe,
    SearchPipe,
    SecureVideoUrlPipePipe,
    SortByPipe,
    ToClassPipe,
    ColumnTooltipPipe,
    DataCellFormatterPipe,
    CombineWithPipe,
    GetCountByPropertyPipe,
  ],
  exports: [
    ArrayJoinPipe,
    CustomFuncFilterPipe,
    DateWithFormatPipe,
    EllipsisPipe,
    HideFlaggedItemsPipe,
    MomentTimezonePipe,
    TranslatePropertyTypePipe,
    SearchPipe,
    SecureVideoUrlPipePipe,
    SortByPipe,
    ToClassPipe,
    ColumnTooltipPipe,
    DataCellFormatterPipe,
    CombineWithPipe,
    GetCountByPropertyPipe,
  ],
})
export class SharedPipesModule {}
